import { Box, Typography } from '@mui/material';
import logo from '../assets/rounded_logo.svg';

interface HeaderProps {
    headerText?: React.ReactNode;
    headerButton: React.ReactNode;
}

export const Header = ({ headerText, headerButton }: HeaderProps) => {
    return (
        <Box
            display="flex"
            justifyContent="space-between"
            pt={2}
            width="100%"
            alignItems={'center'}
        >
            {/* Static Logo */}
            <Box display="flex" alignItems="center" gap={2}>
                <img
                    src={logo}
                    alt="Heyy Property Logo"
                    style={{
                        height: '60px',
                        width: 'auto'
                    }}
                />
                <Typography variant="h6">{headerText}</Typography>
            </Box>
            {/* Dynamic Button */}
            <Box display="flex" gap={4}>
                {headerButton}
            </Box>
        </Box>
    );
};
